import * as React from "react";
import { useCpFormValue } from "../../gvc/testNewForm/utils";

interface Props extends React.PropsWithChildren {
  name: string;
  checkFn: (value: string | boolean) => boolean;
}
export const Only: React.FC<Props> = ({ name, checkFn, children }) => {
  return null;

  // TODO not value when uncommented, any value
  // const value = useCpFormValue(name);

  // const canShow = React.useMemo(() => {
  //   return checkFn(value);
  // }, [name, value, checkFn]);

  // if (!canShow) {
  //   return null;
  // }

  // return children;
};
